export default "__VITE_ASSET__CHX73XW6__"